var isNumber = {exports: {}};

export { isNumber as __module };
